import { useCookieConsent } from 'contexts/CookieConsentContext';
import { ObservableLabels, ImpressionEvent } from './types';
import { useUILanguage } from 'hooks/useUILanguage';
import { trackEvents } from 'services/yleAnalyticsSdk';
import { useYleSk } from './useYleSk';
import { useCookies } from './useCookies';
import { shouldSendImpressionAnalytics } from 'services/yleConsentSdk';
import { useCallback } from 'react';

type Props = {
  uiElementPosition: number;
  uiElementType: string;
};

export const useClickCapture = ({
  uiElementPosition,
  uiElementType,
}: Props) => {
  const consent = useCookieConsent();
  const impressionCookiesRef = useCookies();
  const yle_sk = useYleSk();
  const yle_ui_language = useUILanguage();

  const onClick = useCallback(
    (elementAttributes: ObservableLabels) => {
      if (!shouldSendImpressionAnalytics(consent)) return;

      const eventData: ImpressionEvent = {
        impression_type: 'click',
        impression_timestamp: Date.now(),
        yle_vrs_platform: 'desktop',
        yle_vrs_device: 'browser',
        yle_sk,
        yle_ui_language,
        service_id: 'areena',
        ui_element_position: uiElementPosition,
        ui_element_type: uiElementType,
        ...elementAttributes,
        ...impressionCookiesRef.current,
      };

      trackEvents([eventData]);
    },
    [
      consent,
      impressionCookiesRef,
      uiElementPosition,
      uiElementType,
      yle_sk,
      yle_ui_language,
    ]
  );

  return onClick;
};
